import React from "react";
import ContactForm from "./form";
import styles from "./form_section.module.scss";

export const ContactusFormSection = () => {
  return (
    <section className={styles.section_form}>
      <div className="container">
        <ContactForm />
      </div>
    </section>
  );
};

export default ContactusFormSection;
